import { useMemo } from 'react';
import { useProjectTeamMembers } from '@/hooks/ReactQueryHooks/useProjectQuery';
import { useUsers } from '@/hooks/ReactQueryHooks/useUsersQuery';
import type { UserOption } from '@/types/Constants';
import type { IUser } from '@/types/User';

export const isDrawApproverOptionEqual = (option: unknown, value: unknown) => (option as UserOption)?.id === (value as UserOption)?.id;

export function mapUsersToApproverOptions(users: Pick<IUser, 'id' | 'name'>[]): UserOption[] {
  return users.map(({ id, name }) => ({ id, name }));
}

export function useDrawApproverOptions(projectId: number) {
  const teamQuery = useProjectTeamMembers({ projectId });
  const usersQuery = useUsers({ params: { active: 'true' } });

  const options = useMemo<UserOption[]>(() => {
    const internalTeam = teamQuery.data?.data?.internal ?? [];
    if (internalTeam.length > 0) {
      return mapUsersToApproverOptions(internalTeam);
    }

    const users = usersQuery.data?.data ?? [];
    return mapUsersToApproverOptions(users);
  }, [teamQuery.data?.data?.internal, usersQuery.data?.data]);

  return {
    options,
    isLoading: teamQuery.isLoading || usersQuery.isLoading,
  };
}
